/**
 * Created by alvinoktavianus on 5/17/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import Header from '../Header'
import BillingReceiptForm from './BillingReceiptForm'
import { payMokaSubscription } from 'actions/setting/billing'
import LoadingSpinner from 'components/LoadingSpinner'
import styles from './BillingReceipt.css'

class BillingReceipt extends Component {
  render () {
    let {payButtonClicked, buttonMessage, showLoadingSpinnerPage} = this.props
    return (
      <div className={showLoadingSpinnerPage ? styles['load-billing-receipt'] : ''}>
        <Header title='billing' />
        <div className={styles['loading-receipt']}>
          <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
        </div>
        {!showLoadingSpinnerPage &&
          <BillingReceiptForm
            onSubmit={this._handleSubmit}
            payButtonClicked={payButtonClicked}
            buttonMessage={buttonMessage} />
        }
      </div>
    )
  }

  _handleSubmit = () => {
    let {currentSubscriptionRules, outlets, totalBillingPrice, featureSubscriptionStatus, pendingPaymentMessage, isDeleted} = this.props
    if (pendingPaymentMessage) {
      //  do nothing
    } else {
      const mapedOutlets = _.mapKeys(outlets, 'id')
      let purchasedOutlets = []
      let activatedFeatures = []
      _.map(isDeleted, (value, key) => { if (!value) purchasedOutlets.push(mapedOutlets[key]) })
      _.forEach(featureSubscriptionStatus, (feature) => {
        if (feature.is_active && feature.is_subscribing) {
          activatedFeatures.push(feature.id)
        }
      })
      this.props.dispatch(payMokaSubscription(totalBillingPrice, currentSubscriptionRules, purchasedOutlets, activatedFeatures))
    }
  }
}

function mapStateToProps (state) {
  let {rules, currentSubscriptionRules, outlets, payButtonClicked, buttonMessage, totalBillingPrice, featureSubscriptionStatus, pendingPaymentMessage, isDeleted} = state.setting.billing
  let {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    rules,
    currentSubscriptionRules,
    outlets,
    payButtonClicked,
    buttonMessage,
    totalBillingPrice,
    featureSubscriptionStatus,
    pendingPaymentMessage,
    showLoadingSpinnerPage,
    isDeleted
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingReceipt)



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/BillingReceipt/BillingReceipt.js